import React from 'react';
import BottomNav from '../components/BottomNav';

export default function Help() {
  return (
    <div className="h-screen max-h-screen bg-gray-800 flex flex-col overflow-hidden">
      <div className="flex-1 min-h-0 flex flex-col items-center justify-center p-6 text-center">
        <h1 className="text-3xl font-bold text-white mb-4">Help</h1>
        <p className="text-gray-300 max-w-md">
          This help page is coming soon. In the meantime, please use the Setup and Timer screens to manage your competition and timing.
        </p>
      </div>
      <BottomNav />
    </div>
  );
}
